/**
 * This const returns true if we are running in test mode.
 */
const isRunningInTestRuntime = import.meta.env.VITE_MOCKING_ENABLED === 'true';

export default isRunningInTestRuntime;
